/**
@author ouycx
@desc  “豁免及简化识别”弹窗
*/
<template>
  <div class="mask flex flex-middle flex-center">
    <el-container class="wrap">
      <el-header>
        <div class="title">
          <span>{{ title }}</span>
        </div>
      </el-header>
      <div class="content">
        <el-main class="dialog-form" v-if="dialogFormVisible">
          <div v-for="(item, index) in detailData" :key="index">
            <span class="key">{{ index + 1 }}.</span>
            <span class="value">{{ item.org }}</span>
          </div>
          <br/>
          <div><span class="label">{{ detailDataSummary }}</span></div>
        </el-main>
        <el-main v-else>
          <table class="dialog-table" cellspacing="0">
            <thead>
            <tr class="dialog-tr">
              <th class="td org-head">{{ orgHead }}</th>
              <th class="td name-head">{{ nameHead }}</th>
            </tr>
            </thead>
            <tbody>
            <tr class="dialog-tr" v-for="(val, $index) in gridData">
              <td class="td">{{ val.org }}<strong>{{ val.orgBold }}</strong>{{ val.orgAfter }}</td>
              <td class="td">{{ val.name }}</td>
            </tr>
            </tbody>
          </table>
        </el-main>
      </div>
    </el-container>
  </div>
</template>
<script>
export default {
  data () {
    return {
      detailData: [{
        org: "机关法人及代表其行使职权的派出机构、临时性机构，包括政党机关、人大机关、政协机关、行政机关、监察机关、司法机关、军事机关等及代表其行使职权的派出机构、临时性机构；"
      }, {
        org: "事业单位；"
      }, {
        org: "基层群众性自治组织法人，包括居民委员会和村民委员会；"
      }, {
        org: "农村集体经济组织法人；"
      }, {
        org: "政府间国际组织、外国政府、外国政府驻华使领馆及办事处等组织及机构。"
      }],
      detailDataSummary: "以上客户无需填写《非自然人账户受益所有人信息申报表》",
      gridData: [{
        org: "国有独资公司、国有控股公司、全民所有制企业、集体所有制企业和联营企业",
        name: "法定代表人"
      }, {
        org: "律师事务所、会计师事务所、资产评估机构、合伙专利代理机构等",
        orgBold: "不具有法人资格",
        orgAfter: "的专业服务机构",
        name: "机构负责人"
      }, {
        org: "农民专业合作社、农民专业合作社联合社等城镇农村的",
        orgBold: "合作经济组织法人",
        name: "法定代表人"
      }, {
        org: "合格境外投资者",
        name: "法定代表人、授权代表或合格境外投资者业务负责人"
      }, {
        org: "社会团体、基金会、社会服务机构等社会组织",
        name: "负责人"
      }],
      orgHead: "简化识别组织（无较高风险情形）",
      nameHead: "受益所有人",
      formLabelWidth: "120px"
    };
  },
  props: {
    title: "",
    dialogFormVisible: false
  },
  created () {
    consoleLog("Exs created");
  },
  mounted () {

  },
  activated () {

  },
  methods: {}
};
</script>
<style lang="less">
.message-wrap {
  width: auto !important;
  min-width: 760px;
  max-width: 900px;

  .wrap {
    .el-header {
      padding-top: 10px;

      .title {
        span {
          font-size: 30px;
          font-weight: bold;
        }
      }
    }
  }

  .content {
    font-size: 20px;
    padding: 10px 20px 0 !important;
  }

  .dialog-form {
    text-align: left;
  }

  .dialog-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    font-size: 18px;

    .org-head {
      width: 600px;
    }

    .name-head {
      width: 400px;
    }

    .dialog-tr {
      .td {
        padding: 12px 15px;
        border: 1px solid #ccc;
        text-align: left;
      }

      &:nth-child(even) {
        background-color: #f9f9f9;
      }
    }

    thead .dialog-tr .td {
      background-color: #f0f0f0;
      font-weight: bold;
    }
  }

  .label {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/ui/default/message/src/content/exsTip.vue